export const RESET_STAR_OBJ = "RESET_STAR_OBJ";
export const RESET_STAR_STATUS = "RESET_STAR_STATUS";
export const STAR_MSG_ERROR = "STAR_MSG_ERROR";

export const STAR_MSG = "STAR_MSG";
export const STARRED_MSG = "STARRED_MSG";
